export default {
  path: '/squad',
  name: 'Squad',
  redirect: '/squad/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      name: 'squadLsit',
      component: () => import('@/views/squad'),
      meta: { requiresAuth: true }
    },
    {
      path: 'squadList',  // 教练员账户，球队列表
      name: 'SquadList',
      component: () => import('@/views/squad/SquadList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detail',
      name: 'squadDetail',
      component: () => import('@/views/squad/Detail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'addSquad',
      name: 'addSquad',
      component: () => import('@/views/squad/AddSquad'),
      meta: { requiresAuth: true }
    },
    {
      path: 'adjust',
      name: 'squadAdjust',
      component: () => import('@/views/squad/Adjustment'),
      meta: { requiresAuth: true }
    }
  ]
}
